import React from 'react';

import {getLocalizedStrings} from '@/services/localization/localizationService';

import HomePageForYouContainer from './HomePageForYouContainer/HomePageForYouContainer';

const HomePageTextTopItem = (props) => {
    const {banner, promotedBadgeType} = props;
    const {
        titleKey,
        subTitleKey,
        descriptionKey,
        promotionKey,
        imageMedia,
        videoPath,
        isGradient,
        isDarkBannerText,
        amplitudeTrackingValue,
        action,
        actionAriaLabelKey,
    } = banner;
    const localizedStrings = getLocalizedStrings();

    return (
        <HomePageForYouContainer
            imageMedia={imageMedia}
            videoPath={videoPath}
            externalLink={action}
            isDarkText={isDarkBannerText}
            isBigTitle
            promotedBadgeType={promotedBadgeType}
            badgeText={localizedStrings[promotionKey]}
            titleText={localizedStrings[titleKey]}
            subTitleText={localizedStrings[subTitleKey]}
            descriptionText={localizedStrings[descriptionKey]}
            amplitudeTrackingValue={amplitudeTrackingValue}
            linearGradient={isGradient}
            ariaLabelKey={actionAriaLabelKey}
        />
    );
};

export default HomePageTextTopItem;
